export default __webpack_public_path__ + "media/images/iui/backButton-225ad2f405293ee4097dcdb96986947b.png";